module.exports = __webpack_public_path__ + "static/mo-20a72718e8279cc9d45a9b96ea31d990.jpg";